import { render, staticRenderFns } from "./VersionConfig.vue?vue&type=template&id=8048f80c&scoped=true"
import script from "./VersionConfig.vue?vue&type=script&lang=ts"
export * from "./VersionConfig.vue?vue&type=script&lang=ts"
import style0 from "./VersionConfig.vue?vue&type=style&index=0&id=8048f80c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8048f80c",
  null
  
)

export default component.exports